import React, { useState } from "react";
import { PhoneIcon, ChevronDownIcon } from "../../../../helper/HwIcon";
import { countryWithDialCode } from "../../../../helper/CountryWithDialCode";
import HwPhoneCodeSelect from "../../../../component/HwPhoneCodeSelect";

export const HotelContactDetailsForm = (props) => {
  const [open, setOpen] = useState(!!props.defaultOpen);
  const values = props.values ?? {};
  const touched = props?.touched ?? {};
  const errors = props?.errors ?? {};
  const preview = props?.preview;

  const _setFieldValue = (key, val) => {
    props.setFieldValue(key, val);
  };

  const countryWithDialCodeArr = countryWithDialCode();
  const countryData =
    countryWithDialCodeArr?.map?.((items) => ({
      value: items.country_dial_code,
      label: `${items?.country_code?.toUpperCase()} (${items.country_dial_code
        })`,
      country_code: items.country_code,
    })) ?? [];

  if (preview) {
    const collapsible = props.collapsible;
    const showBody = !collapsible || open;
    return (
      <div className="hw-passenger--listShow__widgetContact hw-hotel--reviewContact">
        <div
          className={`hw-exchk--sectionHead ${collapsible ? "hw-exchk--sectionHead__toggle" : ""} ${showBody ? "is-open" : ""}`}
          onClick={collapsible ? () => setOpen((v) => !v) : undefined}
          role={collapsible ? "button" : undefined}
        >
          <span className="hw-exchk--sectionIcon"><PhoneIcon /></span>
          <span className="hw-exchk--sectionTitle">Contact Details</span>
          {collapsible ? (
            <span className="hw-exchk--sectionToggle">
              <span className="hw-exchk--sectionChevron"><ChevronDownIcon /></span>
            </span>
          ) : null}
        </div>
        {showBody ? (
          <div className="hw-hotel--reviewContactRows">
            <div className="hw-hotel--reviewRow">
              <span className="hw-hotel--reviewRowLbl">Phone</span>
              <span className="hw-hotel--reviewRowVal">
                {values.contactDetails?.phoneCode?.value}{" "}
                {values.contactDetails?.phoneNumber}
              </span>
            </div>
            <div className="hw-hotel--reviewRow">
              <span className="hw-hotel--reviewRowLbl">Email</span>
              <span className="hw-hotel--reviewRowVal">
                {values.contactDetails?.email}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    );

  }
  return (
    <>
      <div className="hw-passenger--listShow__widget hw-hotelContact--listShow__widget">
        <div className="hw-exchk--sectionHead">
          <span className="hw-exchk--sectionIcon"><PhoneIcon /></span>
          <span className="hw-exchk--sectionTitle">Contact Details</span>
        </div>
        <div className="hw-passenger--detailsGroup">
          <div className="hw-passenger--fareShowToggleContent">
            <div className="row">
              <div className="col-md-8 col-xl-7">
                <div className="hw-contact--inputSingleField">
                  <div className="hw-inner--fullWidth hw--hotel-phonecode">
                    <HwPhoneCodeSelect
                      placeholder="Phone Code*"
                      options={countryData}
                      value={values.contactDetails?.phoneCode}
                      onChange={(selected) => {
                        _setFieldValue(`contactDetails[phoneCode]`, selected);
                      }}
                      error={
                        touched?.contactDetails?.phoneCode &&
                        errors?.contactDetails?.phoneCode
                      }
                    />
                    {touched?.contactDetails?.phoneCode &&
                      errors?.contactDetails?.phoneCode ? (
                      <p className="hw-p-error-cls">
                        {errors?.contactDetails?.phoneCode}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="input-m--field hw-hotel-number">
                    <input
                      onChange={(event) => {
                        _setFieldValue(
                          "contactDetails[phoneNumber]",
                          event.target.value
                        );
                      }}
                      value={values.contactDetails?.phoneNumber}
                      placeholder="Mobile Number*"
                      type="text"
                      id="Mobile-number*"
                      className="hw-form--input"
                      name="contactDetails[phoneNumber]"
                    />
                    {touched?.contactDetails?.phoneNumber &&
                      errors?.contactDetails?.phoneNumber ? (
                      <p className="hw-p-error-cls">
                        {errors?.contactDetails?.phoneNumber}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-xl-5">
                <input
                  value={values.contactDetails?.email || ""}
                  placeholder="Email*"
                  id="email"
                  className="hw-form--input"
                  onChange={(event) => {
                    _setFieldValue(`contactDetails[email]`, event.target.value);
                  }}
                  name="contactDetails[email]"
                />
                {touched?.contactDetails?.email &&
                  errors?.contactDetails?.email ? (
                  <p className="hw-p-error-cls">
                    {errors?.contactDetails?.email}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};
